import React, { useState, useMemo } from 'react';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import { useTrans } from 'utils/localisation';
import { useWindowResize } from 'utils/hooks';
import { usePhotoGalleryInfo } from 'staticQueries/photo-gallery-info';
import Image from './Image';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './PhotoGallery.module.scss';

function PhotoGallery({ title }) {
  const items = usePhotoGalleryInfo();
  const t = useTrans(['common']);
  const limiter = 5;
  const [count, setCount] = useState(limiter);

  const { width } = useWindowResize();
  const isMobile = width <= 545;

  const seeMoreHandle = () => {
    setCount(count + limiter);
  };

  const seeLessHandle = () => {
    setCount(limiter);
  };

  const sortedItems = useMemo(() => {
    const result = [...items];
    if (isMobile) {
      for (let i = 7; i < result.length; i += 8) {
        if (i - 2 >= 0) {
          const temp1 = result[i];
          const temp2 = result[i - 2];
          result[i] = result[i - 1];
          result[i - 1] = temp2;
          result[i - 2] = temp1;
        }
      }
      return result;
    }
    return items;
  }, [isMobile]);

  return (
    <Container background="transparent">
      <div className={styles.wrapper}>
        {title && (
          <Title color="white" tag="h2">
            {title}
          </Title>
        )}
        <div className={styles.gallery}>
          <div className={styles.row}>
            {sortedItems.slice(0, count).map((item, i) => (
              <Image key={`item-${i}`} item={item} index={i} items={sortedItems} />
            ))}
          </div>
        </div>
        <div className={styles.seeMoreRow}>
          {count < items?.length ? (
            <button onClick={seeMoreHandle} className={styles.seeMore}>
              {`${t('seeMore')} (${items?.length - count})`}
            </button>
          ) : (
            <button onClick={seeLessHandle} className={styles.seeLess}>
              {t('showLess')}
            </button>
          )}
        </div>
      </div>
    </Container>
  );
}

PhotoGallery.displayName = 'PhotoGallery';

export default withErrorBoundary(PhotoGallery);
